module.exports = __webpack_public_path__ + "img/phone-white-no-notch.3e07931e.png";